import React, { PropsWithChildren } from 'react';
import { Box, Text } from '@fullstory/components';

export interface LibraryFormControlProps
  extends Pick<
    React.ComponentProps<typeof Box>,
    'margin' | 'marginTop' | 'marginRight' | 'marginBottom' | 'marginLeft'
  > {
  testId?: string;
  label?: string;
}

export const LibraryFormControl: React.FC<PropsWithChildren<LibraryFormControlProps>> = ({
  testId,
  label,
  children,
  ...marginProps
}) => (
  <Box data-component="LibraryFormControl" testId={testId} {...marginProps}>
    {label && (
      <Box marginBottom={8}>
        <Text appearance="bodySmall" color="default">
          {label}
        </Text>
      </Box>
    )}
    {children}
  </Box>
);
